import React, { useState } from 'react';

const ShareLinkButton = ({ className = '' }) => {
  const [copied, setCopied] = useState(false);

  const handleCopy = async () => {
    try {
      await navigator.clipboard.writeText(window.location.href);
      setCopied(true);
      setTimeout(() => setCopied(false), 2000);
    } catch (err) {
      console.error('Impossible de copier le lien :', err);
    }
  };

  return (
    <button
      type="button"
      className={`btn btn-sm btn-outline-primary ${className}`}
      onClick={handleCopy}
    >
      {copied ? '✓ Lien copié !' : '🔗 Copier le lien'}
    </button>
  );
};

export default ShareLinkButton;
